import { render } from "./WatchingAnime.vue?vue&type=template&id=b43848b2"
import script from "./WatchingAnime.vue?vue&type=script&lang=js"
export * from "./WatchingAnime.vue?vue&type=script&lang=js"

import "./WatchingAnime.vue?vue&type=style&index=0&id=b43848b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__